/**
 * DevExtreme (esm/data/query_implementation.js)
 * Version: 23.2.10
 * Build date: Mon Oct 28 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import arrayQueryImpl from "./array_query";
import remoteQueryImpl from "./remote_query";
export var queryImpl = {
    array: arrayQueryImpl,
    remote: remoteQueryImpl
};
